export * from "./competency-cell";
